

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/login/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/5.C0r6B3L7.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/BSTIXOHC.js","_app/immutable/chunks/sz5a-fN3.js","_app/immutable/chunks/CTRjNHmM.js","_app/immutable/chunks/DMZiD_i_.js"];
export const stylesheets = [];
export const fonts = [];
